/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { GetProductCategoryResponse as BackendCoreApiModelsAppProductCategoryGetProductCategoryResponse } from '../models/Backend/Core/Api/Models/App/Product/Category/get-product-category-response';
import { GetDocumentRequest as BackendCoreApiModelsAppProductDocumentGetDocumentRequest } from '../models/Backend/Core/Api/Models/App/Product/Document/get-document-request';
import { ProductDocumentCollectionResponse as BackendCoreApiModelsAppProductDocumentProductDocumentCollectionResponse } from '../models/Backend/Core/Api/Models/App/Product/Document/product-document-collection-response';
import { RemoveDocumentRequest as BackendCoreApiModelsAppRemoveDocumentRequest } from '../models/Backend/Core/Api/Models/App/remove-document-request';
import { SimpleResponse as SharedKernelModelsSimpleResponse } from '../models/SharedKernel/Models/simple-response';

@Injectable({
  providedIn: 'root',
})
export class ProductDocumentBackendService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation createProductDocument
   */
  static readonly CreateProductDocumentPath = '/api/product/document/create';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createProductDocument$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createProductDocument$Plain$Response(params?: {
    body?: {

/**
 * ProductId
 */
'ProductId'?: number;

/**
 * Name
 */
'Name'?: string;

/**
 * Link
 */
'Link'?: string;

/**
 * File
 */
'File'?: Blob;

/**
 * Leírás
 */
'Description'?: string;
}
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductDocumentBackendService.CreateProductDocumentPath, 'post');
    if (params) {
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createProductDocument$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createProductDocument$Plain(params?: {
    body?: {

/**
 * ProductId
 */
'ProductId'?: number;

/**
 * Name
 */
'Name'?: string;

/**
 * Link
 */
'Link'?: string;

/**
 * File
 */
'File'?: Blob;

/**
 * Leírás
 */
'Description'?: string;
}
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.createProductDocument$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createProductDocument$Json()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createProductDocument$Json$Response(params?: {
    body?: {

/**
 * ProductId
 */
'ProductId'?: number;

/**
 * Name
 */
'Name'?: string;

/**
 * Link
 */
'Link'?: string;

/**
 * File
 */
'File'?: Blob;

/**
 * Leírás
 */
'Description'?: string;
}
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductDocumentBackendService.CreateProductDocumentPath, 'post');
    if (params) {
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createProductDocument$Json$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createProductDocument$Json(params?: {
    body?: {

/**
 * ProductId
 */
'ProductId'?: number;

/**
 * Name
 */
'Name'?: string;

/**
 * Link
 */
'Link'?: string;

/**
 * File
 */
'File'?: Blob;

/**
 * Leírás
 */
'Description'?: string;
}
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.createProductDocument$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation removeProductDocument
   */
  static readonly RemoveProductDocumentPath = '/api/product/document/remove';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeProductDocument$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  removeProductDocument$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppRemoveDocumentRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductDocumentBackendService.RemoveProductDocumentPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `removeProductDocument$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  removeProductDocument$Plain(params?: {
    body?: BackendCoreApiModelsAppRemoveDocumentRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.removeProductDocument$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeProductDocument$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  removeProductDocument$Json$Response(params?: {
    body?: BackendCoreApiModelsAppRemoveDocumentRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductDocumentBackendService.RemoveProductDocumentPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `removeProductDocument$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  removeProductDocument$Json(params?: {
    body?: BackendCoreApiModelsAppRemoveDocumentRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.removeProductDocument$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation getProductDocument
   */
  static readonly GetProductDocumentPath = '/api/product/document/get';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProductDocument$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getProductDocument$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppProductDocumentGetDocumentRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppProductCategoryGetProductCategoryResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductDocumentBackendService.GetProductDocumentPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppProductCategoryGetProductCategoryResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getProductDocument$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getProductDocument$Plain(params?: {
    body?: BackendCoreApiModelsAppProductDocumentGetDocumentRequest
  }): Observable<BackendCoreApiModelsAppProductCategoryGetProductCategoryResponse> {

    return this.getProductDocument$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppProductCategoryGetProductCategoryResponse>) => r.body as BackendCoreApiModelsAppProductCategoryGetProductCategoryResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProductDocument$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getProductDocument$Json$Response(params?: {
    body?: BackendCoreApiModelsAppProductDocumentGetDocumentRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppProductCategoryGetProductCategoryResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductDocumentBackendService.GetProductDocumentPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppProductCategoryGetProductCategoryResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getProductDocument$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getProductDocument$Json(params?: {
    body?: BackendCoreApiModelsAppProductDocumentGetDocumentRequest
  }): Observable<BackendCoreApiModelsAppProductCategoryGetProductCategoryResponse> {

    return this.getProductDocument$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppProductCategoryGetProductCategoryResponse>) => r.body as BackendCoreApiModelsAppProductCategoryGetProductCategoryResponse)
    );
  }

  /**
   * Path part for operation getProductDocuments
   */
  static readonly GetProductDocumentsPath = '/api/product/document/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProductDocuments$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProductDocuments$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppProductDocumentProductDocumentCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductDocumentBackendService.GetProductDocumentsPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppProductDocumentProductDocumentCollectionResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getProductDocuments$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProductDocuments$Plain(params?: {
  }): Observable<BackendCoreApiModelsAppProductDocumentProductDocumentCollectionResponse> {

    return this.getProductDocuments$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppProductDocumentProductDocumentCollectionResponse>) => r.body as BackendCoreApiModelsAppProductDocumentProductDocumentCollectionResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProductDocuments$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProductDocuments$Json$Response(params?: {
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppProductDocumentProductDocumentCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductDocumentBackendService.GetProductDocumentsPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppProductDocumentProductDocumentCollectionResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getProductDocuments$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProductDocuments$Json(params?: {
  }): Observable<BackendCoreApiModelsAppProductDocumentProductDocumentCollectionResponse> {

    return this.getProductDocuments$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppProductDocumentProductDocumentCollectionResponse>) => r.body as BackendCoreApiModelsAppProductDocumentProductDocumentCollectionResponse)
    );
  }

}
